<template>
  <div v-if="load">
    <scale-loader />
  </div>
  <div v-else-if="profile == null">
    <div class="wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center">
              <h2 class="title text-danger">
                Device: {{ cur_id }} not found
              </h2>
              <router-link :to="{path:'/device_list'}">
                To List device
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <tabs
    v-else
    parent="device"
  >
    <tab
      id="profile"
      :name="translate('device.section.profile')"
      :href="url+'/profile'"
      :is-visible="isTabVisible('profile')"
    >
      <Profile
        :device="profile"
        :simcard_list="simcard_list"
        :device_monitor="device_monitor"
        :client_request="client_request"
        :available_actions="available_actions"
        @change="OnChange"
        @update_sim="getSimcardList"
      />
    </tab>

    <tab
      id="stats"
      :name="translate('device.section.stats')"
      :href="url+'/stats?&speed=false&rssi=false&temper=false&ifaces=false&cpu=false&simcard_status=true'"
      :is-visible="isTabVisible('stats')"
    >
      <Statistics
        :dev_fid="cur_id"
        :profile="profile"
      />
    </tab>

    <tab
      id="config"
      :name="translate('device.section.config')"
      :href="url+'/config'"
      :is-visible="isTabVisible('config')"
    >
      <configuration :dev_fid="cur_id" :dev_id="dev_id"/>
    </tab>

    <tab
        id="tracking"
        :name="translate('device.section.tracking')"
        :href="url + '/tracking'"
        :is-visible="isTabVisible('tracking')"
    >
      <tracking
          :dev_id="profile.id"
          :dev_fid="cur_id"
          :swarm="profile.swarm"
          :lora="profile.lora"
      />
    </tab>

    <tab
        id="traffic"
        :name="translate('device.section.traffic')"
        :href="url + '/traffic'"
        :is-visible="isTabVisible('traffic')"
    >
      <traffic
          :dev_id="dev_id"
          :simcard_list="simcard_list"
      />
    </tab>

    <tab
        id="tariffication"
        :name="translate('device.section.tariffication')"
        :href="url+'/tariffication'"
        :is-visible="isTabVisible('tariffication')"
    >
      <Tariffication
          :dev_fid="cur_id"
      />
    </tab>

    <tab
      id="logs"
      :name="translate('device.section.logs')"
      :href="url + '/logs'"
      :is-visible="isTabVisible('logs')"
    >
      <logs :dev_fid="cur_id" />
    </tab>

    <tab
        id="location_history"
        :name="translate('device.section.location_history')"
        :href="url+'/location_history'"
        :is-visible="isTabVisible('location_history')"
    >
      <LocationHistory
          :dev_fid="cur_id"
          :profile="profile"
      />
    </tab>

    <tab
      id="tickets"
      :name="profile?.tickets?.label ? translate('device.section.tickets') + ' (' + profile?.tickets?.label + ')' : translate('device.section.tickets')"
      :is-visible="isTabVisible('tickets')"
      :href="url + '/tickets'"
    >
      <Tickets
        :dev_id="dev_id"
        :dev_fid="cur_id"
      />
    </tab>

    <tab
      id="tasks"
      :name="translate('device.section.tasks')"
      :href="url + '/tasks'"
      :is-visible="isTabVisible('tasks')"
    >
      <Tasks
          :dev_fid="cur_id"
      />
    </tab>

    <tab
      id="ssh"
      :name="translate('device.section.ssh')"
      :href="url + '/ssh'"
      :is-visible="isTabVisible('ssh')"
    >
      <Ssh
        :dev_fid="cur_id"
        :servers="server_list"
      />
    </tab>

    <tab
      id="testing"
      :name="translate('device.section.selftest')"
      :href="url + '/testing'"
      :is-visible="isTabVisible('testing')"
    >
      <Testing
          :profile="profile"
      />
    </tab>

    <tab
        id="ui_config"
        :name="translate('device.section.ui_config')"
        :href="url + '/ui_config'"
        :is-visible="isTabVisible('ui_config')"
    >
      <UIConfiguration
        :dev_id="dev_id"
        :dev_fid="cur_id"
        :interfaces="profile.interfaces"
        :version="profile.version"
      />
    </tab>
  </tabs>
</template>
<script>

import { Tabs, Tab } from "components/UIComponents/Tabs";
import Profile from "./Tabs/Profile/Index.vue";
import Statistics from "./Tabs/Statistics/Index.vue";
import Traffic from "./Tabs/Traffic/Index.vue";
import Tickets from "./Tabs/Tickets/Index.vue";
import Configuration from "./Tabs/Configuration/Index.vue";
import UIConfiguration from "./Tabs/UIConfiguration/Index.vue";
import Logs from "./Tabs/Logs/Index.vue";
import Tasks from "./Tabs/Tasks/Index.vue";
import Tracking from "./Tabs/Tracking/Index.vue";
import Tariffication from "./Tabs/Tariffication/Index.vue";
import Ssh from "./Tabs/Ssh/Index.vue";
import Testing from "./Tabs/Testing/Index.vue";
import LocationHistory from "./Tabs/LocationHistory/Index.vue";


export default {
  name: "Device",
  components: {
    Profile,
    Tariffication,
    Tab,
    Tabs,
    Logs,
    Configuration,
    UIConfiguration,
    Statistics,
    Traffic,
    Tickets,
    Tasks,
    Tracking,
    Ssh,
    Testing,
    LocationHistory
  },
  data() {
    return {
      pred_id: false,
      section: "profile",
      interval: null,
      device: {},
      change: false,
      simcard_list: [],
      device_monitor: {},
      client_request: {},
      available_actions: []
    }
  },
  computed: {
    device_connection(){
      return {
        fid: this.device.profile?.fid,
        status: this.device.profile?.status_info?.online?.status
      }
    },
    server_list(){
      let list = []
      if (this.device.profile?.servers) {
        for (let server of this.device.profile.servers) {
          let name = server.name + "( " + server.ip + ")"
          if (this.check_ip(server.device_ip) && server.proxy === 1 && !list.find(server => server.label === name)) {
            list.push({
              label: server.name + "( " + server.ip + ")",
              id: server.ip + ":" + server.port,
              ip: server.ip,
              port: server.port
            })
          }
        }

        list = [...new Set(list)]
      }
      return list
    },
    url () { return '/device/' + this.$route.params.device_id },
    cur_id () {
      return this.$route?.params?.device_id
    },
    dev_id () { return this.device?.profile?.id },
    profile () {
      //Изменение имени вкладки
      if (this.$route.name === 'device_section' && this.device.profile) {
        this.$store.commit('updateOtherTitle', this.device.profile.user_info.name2 ? this.device.profile.user_info.name2 : this.device.profile.fid)
      }
      return this.device.profile
    },
    load () {
      if (this.device) {
        return this.device.load === undefined || this.device.load
      }
      return true
    }
  },
  watch: {
    device_connection(current, previous){
      if (this.$route.name === 'device_section' && current.fid === this.cur_id &&
          current.fid === previous.fid && previous.status === 0 && current.status === 1) {
        this.getSimcardList()
      }
    },
    dev_id:{
      deep: true,
      handler(new_val, old_val){
        if(old_val && new_val !== old_val){
          this.$store.dispatch("WS_Unsubscribe",`device_update_main.${old_val}`)
          this.$store.dispatch("WS_Unsubscribe",`device_update_simcards.${old_val}`)
          this.$store.dispatch("WS_Unsubscribe",`device_temp.${old_val}`)
          this.$store.dispatch("WS_Unsubscribe",`device_cpu.${old_val}`)
          this.$store.dispatch("WS_Unsubscribe",`device_update_request.${old_val}`)
          // console.log('[UNSUB] handler from watch')
        }
        if (new_val && new_val !== old_val){
          // console.log('[SUB] handler from watch')
          this.connection()
        }
      }
    },
    cur_id () {
      if (this.cur_id && this.$route.name === 'device_section') {
        this.set_device()
        this.getSimcardList()
        this.get_client_request_device()
      } else {
        clearInterval(this.interval)
        clearInterval(this.intervalSimDev)
      }
    },
    $route () {
      if (this.$route.params.device_section === undefined) {
        return false
      }
    },
    load () {
      clearInterval(this.interval)
      if(this.load === false && this.device.profile !== null) {

        this.device_monitor = this.device.profile?.status_info.hardware
        if(this.$store.getters.WsGetStatus === false){
          this.interval = setInterval(() => {
            this.$store.dispatch('updateDeviceProfile', this.cur_id)
            if(this.device.profile?.status_info.hardware)
              this.device_monitor = this.device.profile?.status_info.hardware
          }, this.$store.getters.getDeviceProfileUpdate)
        }
      }
    },
  },

  activated () {
    this.set_device()
    this.getSimcardList()
    this.get_client_request_device()
    this.connection()
  },

  deactivated () {
    this.$store.dispatch("WS_Unsubscribe",`device_update_main.${this.dev_id}`)
    this.$store.dispatch("WS_Unsubscribe",`device_update_simcards.${this.dev_id}`)
    this.$store.dispatch("WS_Unsubscribe",`device_temp.${this.dev_id}`)
    this.$store.dispatch("WS_Unsubscribe",`device_cpu.${this.dev_id}`)
    this.$store.dispatch("WS_Unsubscribe",`device_update_request.${this.dev_id}`)
    this.$store.commit('updateOtherTitle', '')
    clearInterval(this.interval)
    clearInterval(this.intervalSimDev)
  },
  methods: {
    check_ip(ip){
      let arrIp = ip.split(".");
      if (arrIp.length !== 4) {
        return false
      }
      for (let oct of arrIp) {
        if ( isNaN(oct) || Number(oct) < 0 || Number(oct) > 255){
          return false
        }
      }
      return true
    },
    connection(){
      if(this.$store.getters.WsGetStatus && this.dev_id){
        this.$store.dispatch("WS_Subscribe",{ topic: `device_update_main.${this.profile.id}`, func: this.ParseUpdateFromServiceBridge })
        this.$store.dispatch("WS_Subscribe",{ topic: `device_update_simcards.${this.profile.id}`, func: this.ParseUpdateFromServiceBridge })
        this.$store.dispatch("WS_Subscribe",{ topic: `device_cpu.${this.profile.id}`, func: this.ParseDeviceMonitor })
        this.$store.dispatch("WS_Subscribe",{ topic: `device_temp.${this.profile.id}`, func: this.ParseDeviceMonitor})
        if (this.$store.getters.getPermissions.viewClientRequests === true){
          this.$store.dispatch("WS_Subscribe",{ topic: `device_update_request.${this.profile.id}`, func: this.ParseUpdateFromServiceBridge})
        }
      }
    },
    ParseDeviceMonitor(cmd) {
      if(!Array.isArray(cmd.data)){
        switch (cmd.data.subtopic) {
          case "device_cpu":
          case "device_temp":
            this.device_monitor = Object.assign(this.device_monitor, cmd.data)
            break;
        }
      }
    },
    ParseUpdateFromServiceBridge(cmd){
      if(cmd.data?.action === 'UPDATE'){
        switch (cmd.data.subtopic) {
          case "device_update_main":
            if (this.cur_id) this.$store.dispatch('updateDeviceProfile', this.cur_id)
            break;
          case "device_update_simcards":
            if (this.cur_id) this.$http.v1.getDeviceSimcards(this.cur_id, (response) => {
              this.simcard_list = response.data
            })
            break;

          case "device_update_request":
            if (this.cur_id) this.get_client_request_device()
            break;

          default:
            console.log(`ERROR PARSE MESSAGE: Unknown topic - ${event}`)
            break;
        }
      }
    },
    //Видимость вкладок в зависимости от прав пользователя
    isTabVisible(tab) {
      switch(tab) {
        case 'profile': return (this.$store.getters.getPermissions?.viewDeviceProfile === true);
        case 'ssh': return (this.$store.getters.getPermissions?.runDeviceSsh === true) && (this.server_list?.length > 0);
        case 'tariffication': return (this.$store.getters.getPermissions?.viewCommerceData === true);
        case 'tracking': return (this.$store.getters.getPermissions?.viewDeviceTracking === true);
        case 'location_history': return (this.$store.getters.getPermissions?.permissionGod === true);
        case 'tasks': return (this.$store.getters.getPermissions?.viewDeviceTasks === true);
        case 'logs': return (this.$store.getters.getPermissions?.viewDeviceLogs === true);
        case 'config': return (this.$store.getters.getPermissions?.viewDeviceConfig === true);
        case 'tickets': return (this.$store.getters.getPermissions?.permissionSupport === true) && (this.profile?.tickets?.total > 0);
        case 'traffic': return (this.$store.getters.getPermissions?.viewDeviceTraffic === true);
        case 'stats': return (this.$store.getters.getPermissions?.viewDeviceStats === true);
        case 'testing': return (
            this.$store.getters.getPermissions?.viewDeviceSelftestResults === true ||
            this.$store.getters.getPermissions?.viewDeviceSnapshot === true ||
            this.$store.getters.getPermissions?.viewDeviceFactoryTest === true
          );
        case 'ui_config': return (this.$store.getters.getPermissions?.permissionGod === true) && false;
      }
      return false;
    },
    getSimcardList(){
      this.simcard_list = []
      clearInterval(this.intervalSimDev)
      if (this.$store.getters.getPermissions?.viewDeviceSimcardList === true){
        this.$http.v1.getDeviceSimcards(this.cur_id, (response) => {
          this.simcard_list = response.data
        })
        if(this.$store.getters.WsGetStatus === false){
          this.intervalSimDev = setInterval(() => {
            this.$http.v1.getDeviceSimcards(this.cur_id, (response) => {
              this.simcard_list = response.data
            })
          }, this.$store.getters.getDeviceSimcardUpdate)
        }
      }else{
        this.simcard_list = []
      }
    },

    OnChange (value) {
      this.change = value
    },

    get_client_request_device(){
      if (this.$store.getters.getPermissions.viewClientRequests === true){
        this.$http.v1.getClientRequestDevice(this.cur_id, (response) => {
          this.client_request = response.data.client_request !== null ? response.data.client_request : {}
          this.available_actions = response.data.available_actions
        })
      }
    },

    set_device () {
      if (this.cur_id) {
        this.device = this.$store.getters.getDeviceById(this.cur_id)
        if (!this.device.profile ||  this.device.profile?.ts < Date.now()) {
            this.$store.dispatch('updateDeviceProfile', this.cur_id)
        }
        this.device_monitor = this.device.profile?.status_info.hardware
        this.$store.dispatch('updateDeviceList', this.device.profile)
      }
    }
  }
}

</script>
